// extracted by mini-css-extract-plugin
export default {"background":"wrapper_background__T1zLk"};